import { atom } from "recoil";

//Recoil de ajuda para componentes que estão sendo migrados, assim é possível fazer
//let [state, setState] useRecoilState(STATE_OPCIONAL || nullAtom) e depois if(state){...}
export const nullAtom = atom({
  key: "nullAtom",
  default: null,
});
